// extracted by mini-css-extract-plugin
export default {"close_btn":"CloseBtn_close_btn__+zia-"};